import { render, staticRenderFns } from "./TeamInfo.vue?vue&type=template&id=b74ca64c&scoped=true"
import script from "./TeamInfo.vue?vue&type=script&lang=js"
export * from "./TeamInfo.vue?vue&type=script&lang=js"
import style0 from "./TeamInfo.vue?vue&type=style&index=0&id=b74ca64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74ca64c",
  null
  
)

export default component.exports